// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__1I-Oe"};